export {PackageLocalizationProvider, getPackageLocalizationScript} from '../../../src/i18n/server';
